import { DOCUMENT } from "@angular/common";
import { ApplicationRef, Inject, Injectable, Injector, NgZone } from "@angular/core";

@Injectable({ providedIn: 'root' }) // Make the service available application-wide
export class PopoverConfigService {
  constructor(
    @Inject(Injector) public injector: Injector,
    @Inject(ApplicationRef) public applicationRef: ApplicationRef,
    @Inject(NgZone) public ngZone: NgZone,
    @Inject(DOCUMENT) public document: any 
  ) {}
}